<template>
  <div>
    <div class="title-box">
      <span class="title">{{ moduleData.affiliationType }}</span>
    </div>
    <div class="custom-subList">
      <el-table
        class="custom-table"
        :data="tableData"
        :border="true"
        style="width: 100%"
        header-cell-class-name="custom-header"
      >
        <template v-for="(item, index) in moduleData.subs" :key="index">
          <el-table-column min-width="200px" :label="item.title">
            <template #header>
              <span class="required-icon">{{ item.required ? '*' : '' }}</span>
              <span>{{ item.title }}</span>
            </template>
            <template #default="{ row, $index }">
              <div class="val">
                <Render
                  :data="{ ...item }"
                  :index="index + '-' + $index"
                  :value="row[item.field]"
                  :disabled="item.disabled"
                  ref="renderRef"
                  :isTxt="true"
                  :comp-name="item.customField.renderConfig.compName"
                  :renderConfig="item.customField.renderConfig"
                  @changeValue="value => (row[item.field] = value)"
                />
              </div>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>
<script setup lang="ts">
import Render from '@/components/custom/form/components/render.vue'
import { cloneDeep } from '@/utils/tools'

const props = defineProps({
  moduleData: {
    type: Object,
    default: () => {}
  },
  applyIds: {
    type: Object,
    default: () => {}
  },
  comType: {
    type: Number,
    default: 101 // 101 erp   102 bpm
  }
})

watch(
  () => props.moduleData,
  data => {
    data && (tableData.value = cloneDeep(data.tableData) || [])
  },
  {
    deep: true
  }
)
const tableData = ref<Recordable[]>([])
</script>

<style lang="scss" scoped>
.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 38px;
  .title {
    font-size: 14px;
    color: #333333;
    font-weight: 700;
    display: inline-block;
    border-left: 3px solid #5687ff;
    padding-left: 9px;
  }
}
.custom-subList {
  width: 100%;
  height: 100%;
  padding: 0 16px;
  &.reHeight {
    height: calc(100% - 65px);
  }

  :deep(.el-table__body) {
    .el-table__cell {
      padding: 0;
      height: 40px;
      line-height: 40px;
      border-right-color: transparent;
      .cell {
        line-height: 40px;
        font-size: 14px;
        color: #333333;
      }
    }
  }
  :deep(.custom-header) {
    padding: 0;
    height: 40px;
    line-height: 40px;
    background: #f4f4f5 !important;
    .cell {
      line-height: 40px;
      font-size: 14px;
      color: #666666;
      font-weight: 700;
    }
  }
}
.addRow {
  line-height: 48px;
  color: #5687ff;
  display: inline-block;
}
.required-icon {
  color: #f56c6c;
}
</style>
